import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=1a18dc1e&scoped=true&lang=pug&"
import script from "./Transition.vue?vue&type=script&lang=ts&"
export * from "./Transition.vue?vue&type=script&lang=ts&"
import style0 from "./Transition.vue?vue&type=style&index=0&id=1a18dc1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18dc1e",
  null
  
)

export default component.exports